<template>
  <AppsCardQuickDownload :posts="posts" :translate="translate" />
</template>

<script setup>
  
import { useTranslationStore } from '@/stores/translations';

const translationStore = useTranslationStore();
const translate = translationStore.translate;

defineProps({
    posts: {
        type: [Object, Array],
        required: true,
    }
})

</script>
